module.exports = __webpack_public_path__ + "public/images/prizes/prize-3.1234e030212321408c0da3b6ab5287c4.png";